import React from 'react';
import { createBrowserHistory } from 'history';
import { Router } from 'react-router-dom';

// material-ui
import {
  ThemeProvider,
  createMuiTheme,
  responsiveFontSizes,
} from '@material-ui/core/styles';
import MomentUtils from '@date-io/moment';
import teal from '@material-ui/core/colors/teal';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';

// pages
import Apollo from './components/Apollo';
import Pages from './components/Pages';

// material-ui theme
let theme = createMuiTheme({
  palette: {
    primary: teal,
  },
  typography: {
    body1: {
      fontSize: '0.875rem',
      '@media (min-width:960px)': {
        fontSize: '1rem',
      },
    },
    body2: {
      fontSize: '0.75rem',
      '@media (min-width:960px)': {
        fontSize: '0.875rem',
      },
    },
  },
});
theme = responsiveFontSizes(theme);

export const history = createBrowserHistory({
  basename: process.env.REACT_APP_BASENAME,
});

const App = () => {
  return (
    <Apollo>
      <ThemeProvider theme={theme}>
        <MuiPickersUtilsProvider utils={MomentUtils}>
          <Router history={history}>
            <Pages />
          </Router>
        </MuiPickersUtilsProvider>
      </ThemeProvider>
    </Apollo>
  );
};

export default App;
